import _implicitStylesheets from "./reportAbuse.css";
import _implicitScopedStylesheets from "./reportAbuse.scoped.css?scoped=true";
import _wdsTextarea from "wds/textarea";
import _wdsButton from "wds/button";
import _wdsModal from "wds/modal";
import {freezeTemplate, parseFragment, registerTemplate} from "lwc";
const $fragment1 = parseFragment`<div class="disclaimer${0}" type-style="body-2"${2}>${"t1"}</div>`;
const stc0 = {
  slotAssignment: "main-content",
  attrs: {
    "grid": "",
    "axis": "column",
    "row-gap": "large"
  },
  key: 1
};
const stc1 = {
  classMap: {
    "text-area": true
  },
  key: 4
};
const stc2 = {
  slotAssignment: "footer",
  key: 6
};
const stc3 = {
  "cancel-button": true
};
const stc4 = {
  "data-testid": "report-abuse-btn"
};
function tmpl($api, $cmp, $slotset, $ctx) {
  const {b: api_bind, d: api_dynamic_text, sp: api_static_part, st: api_static_fragment, c: api_custom_element, h: api_element} = $api;
  const {_m0, _m1, _m2, _m3} = $ctx;
  return [api_custom_element("wds-modal", _wdsModal, {
    props: {
      "title": $cmp.reportAbuseModalLabels.header,
      "closedFocusTarget": $cmp.closedFocusTarget
    },
    key: 0,
    on: {
      "close": _m0 || ($ctx._m0 = api_bind($cmp.close))
    }
  }, [api_element("div", stc0, [api_static_fragment($fragment1, 3, [api_static_part(1, null, api_dynamic_text($cmp.reportAbuseModalLabels.description))]), api_element("div", stc1, [api_custom_element("wds-textarea", _wdsTextarea, {
    props: {
      "label": $cmp.reportAbuseModalLabels.textAreaLabel,
      "maxLength": "3000",
      "required": true,
      "preventResize": true
    },
    key: 5,
    on: {
      "change": _m1 || ($ctx._m1 = api_bind($cmp.handleCommentChange))
    }
  })])]), api_element("div", stc2, [api_custom_element("wds-button", _wdsButton, {
    classMap: stc3,
    props: {
      "variant": "secondary",
      "label": $cmp.sharedLabels.cancel
    },
    key: 7,
    on: {
      "click": _m2 || ($ctx._m2 = api_bind($cmp.close))
    }
  }), api_custom_element("wds-button", _wdsButton, {
    attrs: stc4,
    props: {
      "disabled": $cmp.isReportingAbuse,
      "label": $cmp.reportAbuseModalLabels.reportAbuseBtn
    },
    key: 8,
    on: {
      "click": _m3 || ($ctx._m3 = api_bind($cmp.reportAbuse))
    }
  })])])];
  /*LWC compiler v7.1.3*/
}
export default registerTemplate(tmpl);
tmpl.stylesheets = [];
tmpl.stylesheetToken = "lwc-5mo789jkiaa";
tmpl.legacyStylesheetToken = "undefined-_reportAbuse";
if (_implicitStylesheets) {
  tmpl.stylesheets.push.apply(tmpl.stylesheets, _implicitStylesheets);
}
if (_implicitScopedStylesheets) {
  tmpl.stylesheets.push.apply(tmpl.stylesheets, _implicitScopedStylesheets);
}
freezeTemplate(tmpl);
